/*
 * File: throttle.ts
 * File Created: 2023-12-20 04:33:10
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2023-12-20 05:46:04
 * Modified By: Val Liu
 * -----
 */

/// A throttled function will execute immediately upon the first call, then,
/// any subsequent calls within the throttle period are ignored.
/// Once the period is over, the next call is allowed and immediately executed, and the cycle repeats.
export function throttle(delay: number, immediateWait: number = 10) {
    return function (_target: any, _propertyKey: string, descriptor: PropertyDescriptor) {
        const originalMethod = descriptor.value;
        let timeout: any = null;
        let lastInvocationTime: number = 0;
        let lastArgs: any[] | null = null;

        descriptor.value = function (...args: any[]) {
            const now = Date.now();

            // If within the immediate wait time, update the last arguments
            if (now - lastInvocationTime < immediateWait) {
                lastArgs = args;
                clearTimeout(timeout);
                timeout = setTimeout(() => {
                    // After the immediate wait time, call with the latest arguments
                    originalMethod.apply(this, lastArgs);
                    lastInvocationTime = Date.now();
                    lastArgs = null;
                }, immediateWait);
            } else if (now - lastInvocationTime >= delay) {
                // If outside both the immediate wait and throttle delay, call immediately
                originalMethod.apply(this, args);
                lastInvocationTime = Date.now();
            }
            // Otherwise, do nothing (ignore the call)
        };

        return descriptor;
    };
}
